import React, { Component } from 'react';
import Chart from "react-apexcharts";
import axios from 'axios'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';

export class PieChart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "pie"
                },
                labels: ['Delivered', 'Undelivered'],
                legend: { position: 'bottom' },

            },
            series: [],
            isLoaded: false,
            filterDateTo: '',
            filterDateFrom: '',
            exportRecords: [],
            totalRecords: [],
            totalOrders: 0,
            delivered: 0,
            undelivered: 0,
            oracleDuplicateCount: 0,
        };

        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(data) {
        this.setState((prevState) => ({
            series: data
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            this.setState({ filterDateFrom: event.target.value })
        }
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const token = localStorage.getItem("authTokenLoop");
        const dataUrl = API_URL + "/Bi_dashboard_otd"

        axios({
            method: 'post',
            url: dataUrl,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data', // Set the Content-Type header to multipart/form-data
                'Authorization': 'Bearer ' + token,
            },
        }).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                const dataArray = [reportData.delivered, reportData.undelivered];
                this.setState({
                    exportRecords: reportData.oracle_duplicate_orders,
                    totalRecords: reportData.total_records || [],
                    totalOrders: reportData.total_orders,
                    delivered: reportData.delivered,
                    undelivered: reportData.undelivered,
                    oracleDuplicateCount: reportData.oracle_duplicate_orders_count,
                    series: dataArray,
                    options: {
                        chart: { type: "pie" },
                        labels: ['Delivered', 'Undelivered'],
                        legend: { position: 'bottom' },
                        dataLabels: {
                            enabled: true,
                            formatter: function(val, opts) {
                                return val.toFixed(1) + '% (' + opts.w.globals.series[opts.seriesIndex] + ')';
                            },
                            style: {
                                fontSize: '14px',
                                colors: ['#fff']
                            }
                        }
                    },
                    isLoaded: true
                });
            } else {
                console.log("No data returned from API")
                this.setState({ isLoaded: true })
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const newFromDate = this.state.filterDateFrom;

        const formData = new FormData();
        formData.append('filter_date_from', newFromDate);
        // formData.append('filter_date_to', newToDate);
    // mark loading and clear current table records so old data doesn't show while fetching
    this.setState({ isLoaded: false, tableRecords: [] })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();
        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_from', formattedDateFrom);
        // formData.append('filter_date_to', formattedDateTo);
        this.setState({ filterDateFrom: formattedDateFrom })
        this.setState({ filterDateTo: formattedDateTo })
        this.getData(formData);
    }

    render() {
        const oracleExportHeaders = [
          { label: "Line ID", key: "LINE_ID" },
          { label: "Invoice Number", key: "INVOICE_NUMBER" },
          { label: "SKU Code", key: "SKU_CODE" },
          { label: "Source Warehouse", key: "SOURCE_WAREHOUSE" },
          { label: "Document Owner", key: "DOCUMENT_OWNER" },
        ];

        const totalRecordsExportData = this.state.totalRecords.map(r => ({
          "Invoice Number":    r.invoice_number,
          "Requested Shipment Date": r.req_shipment_date,
          "Shipment Date" : r.shipment_date,
          "Location Code":    r.location_code,
          "SKU Code":         r.sku_code,
          "SKU Description":  r.sku_description,
          "Transaction Source": r.transaction_source,
          "ISO Order Type":   r.iso_order_type,
          "Shipment Status":  r.tms_shp_status,
        }));

        const approvedShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Approved').length;
        const holdShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Pending').length;
        const attendedShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Attended').length;

        console.log("totalRecords state length:", this.state.totalRecords.length);
        console.log(totalRecordsExportData)

        const currentDate = new Date().toISOString().split('T')[0];
        const exportDate = this.state.filterDateFrom || currentDate;
        const oracleOrdersFileName = `Oracle Overlapped Orders ${exportDate}`;
        const totalRecordsFileName = `Total Records ${exportDate}`;

        return (
            <div className={`card col-12 m-4`} style={{ height: '60Vh' }}>
                <div className='card-header border-0 pt-5'>
                    <div className='row'>
                        <div className='col-10'>
                            <p className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold mb-1'>
                                    On Time Delivery
                                    <br /> <span style={{ color: '#A3A5A6' }}>{this.state.filterDateFrom}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-2 d-flex align-items-center justify-content-end gap-2'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                                style={{ width: '7vh' }}>
                                <i className='fas fa-filter mx-1'></i> Filter
                            </button>
                            <ExcelExport
                              data={this.state.exportRecords}
                              headers={oracleExportHeaders}
                              fileName={oracleOrdersFileName}
                              title="Oracle Overlapped Orders"
                            />
                            <ExcelExport
                              data={totalRecordsExportData}
                              fileName={totalRecordsFileName}
                              title="Total Records"
                            />
                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    {/* <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div> */}

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-5'>
                            {/* Chart area: show loader until chart data is loaded */}
                            {!this.state.isLoaded ? (
                                <div style={{ height: "100%", width: "150%" }}>
                                    <Circles
                                        height="100%"
                                        width="40%"
                                        color="#EA1C26"
                                        ariaLabel="circles-loading"
                                        wrapperStyle={{ padding: "15% 0", marginLeft: "16%" }}
                                        wrapperClass=""
                                        visible={true}
                                    />
                                </div>
                            ) : (
                                <div style={{ height: "31vh" }}>
                                    <Chart
                                        options={this.state.options}
                                        series={this.state.series}
                                        type="pie"
                                        width="100%"
                                        height="150%"
                                    />
                                </div>
                            )}
                        </div>

                        <div className='col-7' style={{ height: "230px", overflow: "auto" }}>
                            {/* Table area: show loader while fetching and avoid showing stale rows */}
                            {!this.state.isLoaded ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '230px' }}>
                                    <Circles height="80" width="80" color="#EA1C26" ariaLabel="table-loading" visible={true} />
                                </div>
                            ) : (
                                <table className='table table-bordered' style={{ border: '1px solid black' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#DBDEE0' }}>
                                            <th className='text-center' style={{ border: '1px solid black', padding: '1%' }}>METRIC</th>
                                            <th className='text-center' style={{ border: '1px solid black', padding: '1%' }}>COUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>Total Orders</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>{this.state.totalOrders}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>Delivered</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>{this.state.delivered}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>Undelivered</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>{this.state.undelivered}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1% 1% 1% 5%', color: '#555' }}>↳ Pending</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%', color: '#555' }}>{holdShipments}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1% 1% 1% 5%', color: '#555' }}>↳ Approved</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%', color: '#555' }}>{approvedShipments}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1% 1% 1% 5%', color: '#555' }}>↳ Attended</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%', color: '#555' }}>{attendedShipments}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>Oracle Overlapped Orders</td>
                                            <td className='text-center' style={{ border: '1px solid black', padding: '1%' }}>{this.state.oracleDuplicateCount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}